import React from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'

import Icon from '../Icons'

class Checkbox extends React.Component {
  render() {
    const { name, label, id, onChange, checked, disabled, className, style, tooltipText } =
      this.props
    return (
      <div
        className={`field field-checkbox ${className} ${disabled ? 'disabled' : ''}`}
        style={style}
      >
        <div className="control">
          <input
            type="checkbox"
            name={name}
            id={id}
            disabled={disabled}
            checked={checked}
            onChange={onChange}
          />
          <label htmlFor={id} style={{ display: 'flex', alignItems: 'center' }}>
            {tooltipText && tooltipText.length && (
              <span data-tip data-for="triggerTip">
                <div style={{ width: '20px', height: '20px', margin: '0 6px 0 10px' }}>
                  <Icon icon="exclamationPoint" />
                </div>
                <ReactTooltip
                  id="triggerTip"
                  multiline={true}
                  place="top"
                  effect="solid"
                  overridePosition={(position) => ({
                    ...position,
                    left: position.left + 5,
                  })}
                >
                  <div style={{ maxWidth: '300px', position: 'relative' }}>{tooltipText}</div>
                </ReactTooltip>
              </span>
            )}
            <span>{label}</span>
          </label>
        </div>
      </div>
    )
  }
}

Checkbox.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  tooltipText: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  style: PropTypes.object,
  checked: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
}

export default Checkbox
